import styled from 'styled-components';
const StyledPaymentItemContainer = styled.div``;
export default StyledPaymentItemContainer;
